// extracted by mini-css-extract-plugin
export default {"toast":"J2wvhBtDBruk4bQB_wSH"};